// src/state/pinia/project.js
//
// ⚠ DEPRECATED — po collapse Project→Site „projekty" nie istnieją w LessSEO.
// Centralną jednostką jest witryna: użyj `useSiteStore()` (state/pinia/site.js).
//
// Ten store zostaje wyłącznie jako warstwa kompatybilności dla pozostałości
// scaffoldu CMS (api/api.js, layouts/vertical.vue, logout, workspaces/*),
// które wciąż go importują. Wszystko zwraca pusto / no-op, więc nic nie wybucha,
// a żadna logika „projektowa" się nie wykonuje. Docelowo do usunięcia razem
// z martwymi widokami views/projects/*.

import { defineStore } from "pinia";

export const useProjectStore = defineStore("project", {
    state: () => ({
        projects: [],
        activeProject: null,
        activeProjectObj: null,
        workspaceProjects: [],
        hasLinkedCommerce: false,
        loading: false,
    }),

    getters: {
        activeProjectCode: () => null,
        hasActiveProject: () => false,
        // Gettery których oczekiwał stary nav-bar z CMS.
        all: () => [],
        allGrouped: () => [],
    },

    actions: {
        // Selektory / reset — no-op (nie ma już aktywnego projektu).
        setActive() {},
        setActiveProject() {},
        reset() {},
        resetStore() {},

        // Fetchery — no-op stuby (BE nie ma już endpointów projektowych).
        async fetchProjects() {},
        async fetchAllProjects() {},
        async fetchAllForActive() {},
        async fetchLinkedCommerce() { return null; },
        async fetchCollections() { return []; },
        async fetchPages() { return []; },
        async fetchMenus() { return []; },
        async fetchBlocks() { return []; },
        async fetchElements() { return []; },
        async fetchSchemas() { return []; },
        async fetchForms() { return []; },
        async fetchShopPages() { return []; },
        async fetchProjectMeta() { return null; },
        updateProjectSetting() {},
    },
});
